var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog && _vm.clue)?_c('customer-filter',{attrs:{"show-dialog":_vm.showDialog,"filterIsBind":true,"default-province":_vm.clue.province_id,"default-city":_vm.clue.city_id,"default-district":_vm.clue.district_id,"clue":_vm.clue},on:{"filterCallback":_vm.watchFilterCallback,"watchModalClose":_vm.watchModalClose}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65f7dfb6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/clue/dialog/contactCustomerDialog.vue
// module id = 1244
// module chunks = 0